import { render, staticRenderFns } from "./bool.vue?vue&type=template&id=2b5bac62"
import script from "./bool.vue?vue&type=script&lang=ts"
export * from "./bool.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports